import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecurityModule } from '@tc/security';
import { SidePanelComponent } from './side-panel.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SecurityModule
  ],
  exports: [
    SidePanelComponent
  ],
  declarations: [
    SidePanelComponent
  ],
  providers: [],
})
export class SidePanelModule {}
